import React, { useMemo } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { ChatMessageLinksProvider } from '@/components/ChatMessageLinksContext';
import { CHAT_MARKDOWN_COMPONENTS } from '@/components/ChatMarkdownComponents';
import { chatbotMarkdownUrlTransform } from '@/lib/chatbotDeepLinks';

const TEXT_SELECT_STYLE = { userSelect: 'text', WebkitUserSelect: 'text' };

export default function ChatMarkdownBody({ text, sender, linkRegistry, people }) {
  const remarkPlugins = useMemo(() => [remarkGfm], []);

  /* 🔴 react-markdown 10 REMOVED `className` AND THROWS ON IT.
   *
   * `<ReactMarkdown className=...>` is a v9 API. v10 keeps a deprecation table and calls
   * `unreachable('Unexpected `className` prop, remove it')` for anything in it — unconditionally,
   * with no NODE_ENV guard, so it throws in production exactly as in dev. There is no error
   * boundary above this component, so React unmounts the tree and the whole chat panel renders
   * BLANK the moment a message contains markdown.
   *
   * Both the `^10.1.0` bump and this className arrived in the same commit (fe31b35, 2026-08-22)
   * and the production bundle ships the pair. Reproduced in dev 2026-10-09 on a restored
   * conversation.
   *
   * The fix is a wrapper: the prose classes style the SUBTREE, so they work identically on a div
   * and the markdown renderer gets no prop it rejects. `style` is still a valid prop in v10 and
   * stays where it was. */
  const proseClasses = `prose prose-sm max-w-none break-words
    prose-pre:whitespace-pre-wrap prose-pre:break-words
    prose-pre:overflow-x-auto prose-code:break-words
    prose-a:break-words
    prose-p:mb-3
    prose-headings:mb-2
    prose-headings:mt-4
    prose-ul:my-2
    prose-ol:my-2
    prose-li:my-1
    ${sender === 'user' ? 'prose-invert' : ''}`;

  return (
    <ChatMessageLinksProvider linkRegistry={linkRegistry} people={people}>
      <div className={proseClasses} style={TEXT_SELECT_STYLE}>
        <ReactMarkdown
          remarkPlugins={remarkPlugins}
          urlTransform={chatbotMarkdownUrlTransform}
          components={CHAT_MARKDOWN_COMPONENTS}
        >
          {text}
        </ReactMarkdown>
      </div>
    </ChatMessageLinksProvider>
  );
}
